import React from 'react';
import * as styles from './base.scss';
import { postJson } from 'Shared/server';
import connect from 'Shared/connect';
import { Main } from 'Shared/PageLayout';
import ProductCarousel from 'Shared/Blocks/ProductCarousel/ProductCarouselBlock';
import { pathCombine } from 'Shared/url';
import { LARGE, MEDIUM, SMALL } from 'Shared/breakpoints';
import classNames from 'classnames';
import SkeletonLoader from '../../Shared/Skeleton/loader';
class ProductRecommendation extends React.Component {
    constructor(props) {
        super(props);
        this.handleSmartRecLoadedEvent = (e) => {
            if (!e.detail)
                return;
            if (!!e.detail.find((x) => x.position == this.props.widgetType)) {
                var productIds = e.detail.find((x) => x.position == this.props.widgetType).recs.map((x) => x.refCode);
                var refCodeAndIds = e.detail.find((x) => x.position == this.props.widgetType).recs.map((x) => { return { refCode: x.refCode, id: x.id }; });
                if (productIds.length) {
                    this.setState({
                        refCodeAndIds: refCodeAndIds
                    }, () => {
                        this.updateRecommendations(productIds);
                    });
                }
            }
        };
        this.handlePeeriusClickTracking = (e) => {
            const code = e.detail.split("_")[0];
            const optimizelyId = this.state.refCodeAndIds.find(entry => entry.refCode === code);
            setTimeout(() => {
                if (!!window["Peerius"]) {
                    window["Peerius"].smartRecsSendClick(optimizelyId.id);
                }
            }, 1000);
        };
        this.updateRecommendations = (productIds) => {
            if (!productIds)
                return;
            const url = (pathCombine("/product", "getproductrecommendationsfor"));
            postJson(url, productIds).then((data) => {
                this.setState({
                    recommendationZone: data,
                    loaded: true,
                    falied: false,
                    waiting: false
                }, () => {
                    this.forceUpdate();
                });
            }).catch(() => {
                this.setState({
                    recommendationZone: null,
                    loaded: true,
                    falied: true,
                    waiting: false
                }, () => this.logError("ProductRecommendations could not be loaded for: " + this.props.code));
            });
        };
        this.state = {
            recommendationZone: null,
            loaded: false,
            falied: false,
            waiting: true,
            refCodeAndIds: []
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.code !== this.props.code) {
            this.setState({
                recommendationZone: null,
                loaded: false,
                falied: false,
                waiting: false
            });
        }
    }
    componentDidMount() {
        this.addSmartRecEventListner();
    }
    componentWillUnmount() {
        this.removeSmartRecEventListner();
    }
    addSmartRecEventListner() {
        document.addEventListener('smartRecLoaded', this.handleSmartRecLoadedEvent);
        document.addEventListener('smartRecInit', this.hadleSmartRecInitEvent);
        document.addEventListener("PeeriusTrackingClick", this.handlePeeriusClickTracking);
    }
    removeSmartRecEventListner() {
        document.removeEventListener('smartRecLoaded', this.handleSmartRecLoadedEvent);
        document.removeEventListener('smartRecInit', this.hadleSmartRecInitEvent);
        document.removeEventListener('PeeriusClickTracking', this.handlePeeriusClickTracking);
    }
    hadleSmartRecInitEvent(e) {
        !!this.setState && this.setState({
            waiting: !this.state.recommendationZone
        });
    }
    getSkeltonLoaderCount() {
        if (this.props.currentBreakpoint < SMALL) {
            return 1;
        }
        else if (this.props.currentBreakpoint <= SMALL) {
            return 2;
        }
        else if (this.props.currentBreakpoint >= MEDIUM && this.props.currentBreakpoint < LARGE) {
            return 3;
        }
        else if (this.props.currentBreakpoint >= LARGE) {
            return 4;
        }
    }
    showCarousel() {
        return !!this.state.loaded && !!this.state.recommendationZone && this.state.recommendationZone.length > 0;
    }
    logError(msg) {
        console.log(msg);
    }
    render() {
        return !this.state.falied && (React.createElement("div", { className: classNames(styles.base) },
            React.createElement(Main, null, !!this.showCarousel() ? (Object.keys(this.state.recommendationZone).map((data, i) => (React.createElement("div", { key: i },
                React.createElement(ProductCarousel, { title: !!this.props.header ? this.props.header : this.state.recommendationZone[i].name, products: this.state.recommendationZone[i].products, width: "", id: data }))))) : (React.createElement("div", { className: classNames(styles.skeletons, { [styles.waiting]: this.state.waiting }) },
                React.createElement(SkeletonLoader, { count: this.getSkeltonLoaderCount(), type: 'gallery' }))))));
    }
}
export default connect((state, ownProps) => ({
    currentBreakpoint: state.currentBreakpoint,
    currentPage: state.currentPage,
}))(ProductRecommendation);
